import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-reference-master',
  templateUrl: './reference-master.component.html',
  styleUrls: ['./reference-master.component.scss']
})
export class ReferenceMasterComponent implements OnInit {
  referenceEditForm!: FormGroup;
  referenceTypes: any[] = [];
  isSaving = false;
  saveMessage = '';
  referenceCodePrefix = 'RM_';

  constructor(private fb: FormBuilder, public appservice: AppService) {
    this.referenceEditForm = this.fb.group({
      add: this.fb.group({
        RG_iid: [0, Validators.required],
        REM_REFid: ['', Validators.required],
        REM_REF_Name: ['', Validators.required]
      })
    });
  }

  ngOnInit(): void {
    this.loadReferenceGroupOptions();
    this.renderEditData();
  }

  loadReferenceGroupOptions(): void {
    this.appservice.getTable('api/Master/Reference_group').subscribe(
      (res: any) => {
        const data = Array.isArray(res) ? res : Array.isArray(res?.record) ? res.record : [];
        this.referenceTypes = data;
      },
      (error) => {
        console.error('Unable to load reference group options', error);
        this.referenceTypes = [];
      }
    );
  }

  renderEditData(): void {
    if (!this.appservice.isedit || !this.appservice.referenceEditData) {
      return;
    }

    const editData: any = this.appservice.referenceEditData;
    const groupId = editData.RG_iid ?? editData.REM_iid ?? '';
    const refId = editData.REM_REFid ?? editData.REM_REF_Code ?? editData.id ?? '';
    const refName = editData.REM_REF_Name ?? editData.Description ?? '';

    this.referenceEditForm.patchValue({
      add: {
        RG_iid: groupId,
        REM_REFid: refId,
        REM_REF_Name: refName
      }
    });

    console.log('Rendering edit data', editData, groupId, refId, refName, this.referenceEditForm.value);
  }
  onSaveReference(): void {
    if (this.referenceEditForm.invalid) {
      this.saveMessage = 'Please complete all required fields.';
      return;
    }

    const values = this.referenceEditForm.get('add')?.value as {
      RG_iid: string | number;
      REM_REFid: string;
      REM_REF_Name: string;
    };

    const payload: any = {
      RM_Code: `${values.RG_iid}`,
      RG_iid: values.REM_REFid,
      Description: values.REM_REF_Name,
      isEdit: this.appservice.isedit,
      REM_Createdby: this.appservice.username
    };

    if (this.appservice.isedit && this.appservice.referenceEditData) {
      payload.id = this.appservice.referenceEditData.id ?? this.appservice.referenceEditData.RG_iid ?? this.appservice.referenceEditData.REM_REFid ?? null;
    }

    this.isSaving = true;
    this.saveMessage = '';

    this.appservice.postTable('api/Master/Insert_Reference_master', payload).subscribe(
      (res: any) => {
        this.isSaving = false;
        this.saveMessage = 'Reference saved successfully.';
        this.appservice.isedit = false;
        this.appservice.referenceEditData = null;
        this.referenceEditForm.reset();
      },
      (error) => {
        this.isSaving = false;
        console.error('Save failed', error);
        this.saveMessage = 'Save failed. Please try again.';
      }
    );
  }

  onCancel(): void {
    this.appservice.isedit = false;
    this.appservice.referenceEditData = null;
    this.saveMessage = '';
    
    this.referenceEditForm.reset();
    this.appservice.goback();
  }
}
